import { createAction } from 'redux-actions';
import { replace } from 'react-router-redux';

import { closeAlert, openSuccessAlert } from 'actions/alert';

import { t } from 'util/i18n';

const setModalBackgroundScrollY = createAction('SET_MODAL_BACKGROUND_SCROLLY', scrollY => {
	if (!document.body.className.includes('no-scroll')) {
		document.body.style.top = `-${scrollY}px`;
		document.body.className += ' no-scroll';
	}
	return scrollY;
});

const restoreModalBackgroundScrollY = createAction(
	'RESTORE_MODAL_BACKGROUND_SCROLLY',
	globalTop => {
		document.body.className = document.body.className.replace(' no-scroll', '');
		document.body.style.top = 'unset';
		window.scrollTo(0, globalTop);
	},
);

export const openMessageModal = createAction('OPEN_MESSAGE_MODAL', (modal, message) => ({
	modal,
	message,
}));

// Set modal background scroll position
export const openMessageModalEpic = (action$, store) =>
	action$.ofType('OPEN_MESSAGE_MODAL').map(() => {
		const { global: { scrollY } } = store.getState();

		return setModalBackgroundScrollY(scrollY);
	});

// Handle open login modal
export const handleLoginModalEpic = action$ =>
	action$
		.ofType('OPEN_MESSAGE_MODAL')
		.filter(
			action =>
				action.payload.modal === 'loginSignup' && action.payload.message.type === 'loginForm',
		)
		.map(() => openSuccessAlert('loginSignup', t('modalLoginSignup:welcomeBack')));

export const closeMessageModal = createAction('CLOSE_MESSAGE_MODAL', modal => dispatch => {
	dispatch(closeAlert(modal));
	return { modal };
});

// Restore modal background scroll position after close modal
export const closeMessageModalEpic = (action$, store) =>
	action$.ofType('CLOSE_MESSAGE_MODAL').map(() => {
		const { modal: { globalTop } } = store.getState();

		return restoreModalBackgroundScrollY(globalTop);
	});

// Handle forget, verify email modal close
export const handleForgetVerifyModalEpic = (action$, store) =>
	action$
		.ofType('CLOSE_MESSAGE_MODAL')
		.filter(action => action.payload.modal === 'loginSignup')
		.map(() => {
			const {
				routing: { locationBeforeTransitions: { pathname } },
				auth: { token: { accessToken } },
			} = store.getState();

			if (
				pathname.includes('forget') ||
				pathname.includes('verify') ||
				pathname.includes('signup') ||
				(pathname.includes('login') && accessToken === '')
			) {
				return replace('/');
			}

			return { type: 'CLOSE_LOGIN_SIGNUP_MODAL' };
		});



// WEBPACK FOOTER //
// ./src/actions/modal.js